enum ParkingLotTypeEnum {
  ExteriorOpen = 'Exterior Open',
  InteriorSecured = 'Interior Secured',
}

export default ParkingLotTypeEnum;
